const facilitiesOpeninghours = () => {
    const facilityLists = document.querySelectorAll('[data-type="facility-list"]'); // Get all lists
    const toggleButtons = document.querySelectorAll('[data-type="facility-opening-btn"]'); // Get all toggle buttons

    toggleButtons.forEach((toggleButton, index) => {
        const facilityList = facilityLists[index];

        if (facilityList && toggleButton) {
            const listItems = facilityList.querySelectorAll('li');

               if (listItems.length <= 1) {
                const icon = toggleButton.querySelector('svg');
                if (icon) {
                    icon.classList.add('invisible');
                }
                toggleButton.setAttribute('aria-hidden', 'true');
                toggleButton.disabled = true;
                return; 
            }


            // Initially hide all items except the first
            listItems.forEach((item, itemIndex) => {
                if (itemIndex > 0) {
                    item.classList.add('hidden');
                }
            });

            toggleButton.addEventListener('click', () => {
                const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';

                listItems.forEach((item, itemIndex) => {
                    if (itemIndex > 0) {
                        item.classList.toggle('hidden', isExpanded);
                    }
                });

                // Toggle button state
                toggleButton.setAttribute('aria-expanded', !isExpanded);

                // Rotate the icon
                const icon = toggleButton.querySelector('svg');
                if (icon) {
                    icon.classList.toggle('rotate-180', !isExpanded);
                }
            });
        }
    });
};
document.addEventListener('DOMContentLoaded', () => {
    facilitiesOpeninghours();
});
